<template>
  <div>
    <section class="content">
      <div class="row center-block">
        <div class="box">
          <!-- Box Header -->
          <div class="box-header">
            <button class="btn btn-default btn-sm" @click.prevent="exportInfluencers">Export</button>

            <!-- Reload button -->
            <b-button variant="primary" size="sm" @click.stop="reloadAll()">
              Reload All
              <i class="fa fa-repeat"></i>
            </b-button>

          </div>

          <!-- Box Body -->
          <div class="box-body">
            <!-- Search input -->
            <div class="row">
              <div class="col-xs-5 search-keyword-wrapper">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search influencers by Tags extracted from NLU"
                  v-model="keyword"
                  @keyup.enter="searchByKeywords()"
                >
              </div>
              <div class="col-xs-1 v-dialog-wrapper">
                <v-dialog v-model="dialog" width="500">
                  <template v-slot:activator="{ on }">
                    <v-icon color="red lighten-2" dark v-on="on">settings</v-icon>
                  </template>

                  <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title>Settings</v-card-title>
                    <v-card-text>
                      <v-text-field outlined v-model="negativeKeyword" type="text" clearable label="Negative Keyword"></v-text-field>
                      <v-divider></v-divider>
                      <p>Negative keyword scope</p>
                      <v-radio-group v-model="negativePeriod">
                        <v-radio :label="'Search period'" :value="'search_period'"></v-radio>
                        <v-radio :label="'Entire Account'" :value="'entire_account'"></v-radio>
                      </v-radio-group>
                      <v-text-field outlined v-model="searchDuration" type="number" label="Search Period(months)"></v-text-field>
                      <v-divider></v-divider>
                      <p>Enable</p>
                      <v-checkbox v-model="computerVison" hide-details :label="`Computer Vision`"></v-checkbox>
                      <v-checkbox v-model="searchNlu" hide-details :label="`NLU`"></v-checkbox>
                      <v-divider></v-divider>
                      <p>Opt-in Only</p>
                      <v-radio-group v-model="optInOnly">
                        <v-radio :label="'Yes'" :value="true"></v-radio>
                        <v-radio :label="'No'" :value="false"></v-radio>
                      </v-radio-group>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="secondary" @click="dialog = false">Confirm</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
              <div class="col-xs-6">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search Influencers by Instagram Handle(username)"
                  v-model="igHandle"
                  id="igHandle"
                  @keyup.enter="paginate()"
                >
              </div>
            </div>

            <!-- Filters -->
            <b-btn class="btn btn-default btn-sm" v-b-toggle.filters>More Filters >></b-btn>
            <b-collapse id="filters">
              <div class="row">
                <div class="col-xs-6 col-sm-3">
                  <label>Influencer Location</label>
                  <v-combobox
                    v-model="influencerGeos"
                    :items="countries"
                    hide-selected
                    multiple
                    outlined
                    clearable
                    small-chips
                  >
                    <template v-slot:selection="data">
                      <v-chip :selected="data.selected" close @input="remove(data.item)">
                        <strong>{{ data.item }}</strong>&nbsp;
                      </v-chip>
                    </template>
                  </v-combobox>
                </div>
              </div>
              <div class="row" align="center">
                <b-btn class="btn btn-primary" @click="paginate()">Apply</b-btn>
                <b-btn class="btn btn-danger" @click="resetFilters()">Reset</b-btn>
              </div>
            </b-collapse>

            <!-- influencer Table -->
            <div class="row">
              <div class="col-xs-12">
                <button
                  id="viewReport"
                  style="display: none"
                  data-toggle="modal"
                  :data-target="audienceDataReportDisplay"
                ></button>
                <button
                  id="viewPosts"
                  style="display: none"
                  data-toggle="modal"
                  :data-target="influencerPostDisplay"
                ></button>
                <v-data-table
                  :headers="fields"
                  :items="items"
                  :pagination.sync="pagination"
                  :expanded-item="expand"
                  :loading="loading"
                  :items-per-page-options="pagination.rowsPerPageItems"
                  :server-items-length="pagination.totalItems"
                  item-key="instagramHandle"
                >
                  <template v-slot:items="props">
                    <tr @click="props.expanded = !props.expanded">
                      <td class="text-xs-left">
                        <v-avatar :size="avatarSize" color="grey lighten-4">
                          <img v-bind:src="props.item.profilePicture" alt="avatar">
                        </v-avatar>
                      </td>
                      <td class="text-xs-left">
                        <a
                          target="_blank"
                          v-bind:href="'https://instagram.com/' + props.item.instagramHandle"
                        >@{{ props.item.instagramHandle }}</a>
                      </td>
                      <td class="text-xs-left">{{ props.item.instagramFullname }}</td>
                      <td class="text-xs-left">{{ props.item.totalFollowers }}</td>
                      <td class="text-xs-left">{{ props.item.totalFollowing }}</td>
                      <td class="text-xs-left">{{ props.item.joinedAt }}</td>
                      <td class="justify-center layout px-0">
                        <!-- View audience data -->
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              medium
                              class="mr-2"
                              v-on="on"
                              color="success"
                              @click.stop="showReport(props.item)"
                            >assessment</v-icon>
                          </template>
                          <span>View Audience Data</span>
                        </v-tooltip>
                        <!-- Show influencer popular posts -->
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              medium
                              class="mr-2"
                              v-on="on"
                              color="success"
                              @click.stop="viewInfluencerPosts(props.item)"
                            >local_library</v-icon>
                          </template>
                          <span>View Posts</span>
                        </v-tooltip>
                        <!-- Assign company -->
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              medium
                              v-if="buttonShow('assignCompany')"
                              v-on="on"
                              color="success"
                              @click.stop="getCompanyDataToView(props.item)"
                            >how_to_reg</v-icon>
                          </template>
                          <span>Assign Company</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>
                  <template v-slot:expand="props" v-slot:items="props">
                    <v-card text>
                      <div class="row">
                        <div class="col-md-3">
                          <v-card-text>
                            <strong>Bank Account:</strong>
                            <span>{{props.item.bankAccount}}</span>
                          </v-card-text>
                          <v-card-text>
                            <strong>Bank Name:</strong>
                            <span>{{props.item.bankName}}</span>
                          </v-card-text>
                        </div>
                        <div class="col-md-3">
                          <v-card-text>
                            <strong>Address:</strong>
                            <span>{{props.item.mailingAddress}}</span>
                          </v-card-text>
                          <v-card-text>
                            <strong>Country:</strong>
                            <span>{{props.item.country}}</span>
                          </v-card-text>
                        </div>
                        <div class="col-md-3">
                          <v-card-text>
                            <strong>Date of Birth:</strong>
                            <span>{{props.item.birthday}}</span>
                          </v-card-text>
                        </div>
                        <div class="col-md-3">
                          <v-card-text>
                            <strong>Engagement Rate:</strong>
                            <span class="engagement">{{props.item.engagementRate}}%</span>
                          </v-card-text>
                        </div>
                      </div>
                    </v-card>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Audience data report modal -->
    <audience-data-report-modal :modalId="audienceDataReportId" :audienceData="audienceDataReport"/>

    <!-- View Influencer post -->
    <influencer-post-modal
      :modalId="influencerPostModalId"
      :title="postsTitle"
      :shortCodes="shortCodes"
    />
  </div>
</template>
<script>
import moment from 'moment';
import config from '@/config';
import InfluencerSearchAPIs from './influencerSearchAPIs';
import AudienceDataReportModal from '../Influencer/AudienceDataReportModal';
import InfluencerPostModal from './InfluencerPostsModal';
import uniq from 'lodash/uniq';

export default {
  name: 'influencer',
  components: {
    AudienceDataReportModal,
    InfluencerPostModal
  },
  data() {
    return {
      audienceDataReportId: 'audience_data_report_modal',
      influencerPostModalId: 'influencerPostModalId',
      audienceDataReport: null,
      sortBy: 'name',
      influencerGeos: [], // new filter influencer
      search: null,
      expand: false, // Close other rows
      shouldCallApi: false,
      loading: false,
      pagination: {
        // v-data-table pagination
        descending: true,
        page: 1,
        sortBy: '',
        rowsPerPage: 20,
        totalItems: 0,
        rowsPerPageItems: [10, 20, 50, 100]
      },
      postsTitle: '',
      avatarSize: 45, // avatar
      countries: ['Singapore', 'Thailand', 'Indonesia', 'Philippines'], // For filter influencer
      shortCodes: [],
      sortDesc: false,
      fields: [
        {
          text: 'Avatar',
          sortable: false
        },
        {
          value: 'instagramHandle',
          text: 'Handle',
          sortable: false
        },
        {
          value: 'instagramFullname',
          text: 'Fullname',
          sortable: false
        },
        {
          value: 'totalFollowers',
          text: 'Followers'
        },
        {
          value: 'totalFollowing',
          text: 'Following',
          sortable: false
        },
        {
          value: 'joinedAt',
          text: 'Joined At',
          sortable: false
        }
      ],
      // Setting search influencer by keyword
      negativeKeyword: '',
      negativePeriod: 'entire_account',
      optInOnly: false,
      searchDuration: 12,
      searchNlu: true,
      computerVison: true,
      dialog: false,
      items: [],
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      keyword: '',
      fromAge: '',
      toAge: '',
      fromFol: '',
      toFol: '',
      fromEng: '',
      toEng: '',
      filGender: 'Any',
      igHandle: '',
      searchedItems: [],
      selectedCountries: ['all'],
      resultMessage: ''
    };
  },
  computed: {
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    updatedOn: function() {
      return moment(this.lastUpdate).fromNow();
    },
    audienceDataReportDisplay: function() {
      return '#' + this.audienceDataReportId;
    },
    influencerPostDisplay: function() {
      return '#' + this.influencerPostModalId;
    },
    availableCountries() {
      // extract the available countries
      return uniq(this.searchedItems.map(item => item.country));
    },
    payload() {
      return {
        filter: {
          geo: this.influencerGeos,
          audience_geo: null,
          igHandle: this.igHandle
        },
        paging: {
          per_page: this.pagination.rowsPerPage <= 0 ? 20 : this.pagination.rowsPerPage,
          page: 1,
          sortBy: this.pagination.sortBy,
          descending: this.pagination.descending
        }
      };
    },
    searchKeywordPayload() {
      return {
        keyword: this.keyword,
        negative_keyword: this.negativeKeyword,
        negative_period: this.negativePeriod,
        opt_in_only: this.optInOnly,
        search_duration: this.searchDuration,
        search_image: false,
        search_nlu: this.searchNlu
      };
    }
  },
  watch: {
    pagination(newVal) {
      if (this.shouldCallApi) {
        this.paginate(newVal.page);
      }
    }
  },
  methods: {
    buttonShow(type) {
      const roleAllow = config['userPermissions']['influencer'][type];
      return roleAllow ? roleAllow.includes(this.currentUserRole) : false;
    },
    updateItems(response) {
      const displayItems = response.influencers.map(element =>
        Object.assign(
          { id: element.id },
          {
            instagramHandle: element.instagram ? element.instagram.instagramHandle : null,
            instagramID: element.instagram ? element.instagram.instagramID : null,
            instagramFullname: element.fullName || element.instagram ? element.instagram.instagramFullname : null,
            totalFollowers: element.instagram ? element.instagram.totalFollowers : 0,
            totalFollowing: element.instagram ? element.instagram.totalFollowing : 0,
            joinedAt: this.formatTime(element.createdAt),
            posts: element.posts || [],
            audience: element.audience || {},
            profilePicture:
              element.audience && element.audience.user_profile
                ? element.audience.user_profile.picture || '/static/img/avatar/user.png'
                : '/static/img/avatar/user.png',
            instagram: element.instagram || {},
            gender: element.gender,
            birthday: element.birthday || 'None',
            mailingAddress: element.mailingAddress || 'None',
            bankAccount: element.bankAccount || 'None',
            bankName: element.bankName || 'None',
            country: element.country || 'None',
            engagementRate:
              element.audience && element.audience.user_profile
                ? (Number(element.audience.user_profile.engagement_rate) * 100).toFixed(2)
                : 0
          }
        )
      );
      this.items = displayItems;
      this.totalRows = response.totalInfluencers;
      // store the searched results for Filtering
      this.searchedItems = displayItems;
    },
    paginate(page = 1) {
      this.currentPage = page;
      this.payload.paging.page = page;
      this.loading = true;
      InfluencerSearchAPIs
        .paginate(this.payload)
        .then(response => {
          this.updateItems(response);
          this.resultMessage = `Showing [` + this.perPage + `] per page of total [` + this.totalRows + `] influencers result.`;
          this.pagination.totalItems = this.totalRows;
          if (this.pagination.rowsPerPage === -1) {
            this.pagination.rowsPerPage = 20;
          }
          this.shouldCallApi = true;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    viewInfluencerPosts(item) {
      let posts = item.posts || [];
      if (posts.length > 0) {
        this.shortCodes = posts.map(item => item.shortCode);
        document.getElementById('viewPosts').click();
        this.postsTitle = `Related Posts(${item.instagramHandle})`;
      } else {
        this.$swal({
          title: 'Empty',
          text: 'Oop!! There are no posts',
          type: 'info'
        });
      }
    },

    showReport(influencer) {
      InfluencerSearchAPIs
        .fetchLocalAudienceReport(influencer.instagramID, influencer.instagramHandle)
        .then(resp => {
          this.audienceDataReport = resp.data;
          document.getElementById('viewReport').click();
        })
        .catch(err => {
          console.error(err);
        });
    },
    editInfluencer(influencerData) {
      // Update the edited content to user
      var selectedIndex = -1;

      this.items.forEach(function(influencer, index) {
        if (influencer.id === influencerData.id) {
          selectedIndex = index;
          return;
        }
      });

      if (selectedIndex !== -1) {
        this.$set(this.items, selectedIndex, influencerData);
      }

      // Do anything like highlighting the edited item
      console.log('influencer edited');
    },
    formatTime(value) {
      return moment(value).format('YYYY-MM-DD hh:mm:ss');
    },
    // Filter the result
    filterItems() {
      // iniitalize default values if the value is null
      let minAge = !this.fromAge ? 0 : this.fromAge;
      let maxAge = !this.toAge ? 150 : this.toAge;
      let minFol = !this.fromFol ? 0 : this.fromFol;
      let maxFol = !this.toFol ? 1000000000 : this.toFol;
      let minEng = !this.fromEng ? 0 : this.fromEng;
      let maxEng = !this.toEng ? 100 : this.toEng;
      let gender = this.filGender === 2 ? 'both' : this.filGender;
      let handle = this.igHandle;
      let countries = this.selectedCountries;

      let filteredItems = [];
      this.searchedItems.forEach(function(item, index) {
        // calculate the age
        let today = moment().format('YYYY');
        let bd = moment(item.birthday).format('YYYY');
        let age = today - bd;

        // handle the multiple country selection
        let countryStatus = false;
        countries.map(cnty => {
          if (cnty === item.country || cnty === 'all') {
            countryStatus = true;
          }
        });

        // for each match cases
        if (
          minAge <= age &&
          maxAge >= age &&
          (minFol <= item.totalFollowers && maxFol >= item.totalFollowers) &&
          (minEng <= item.engagementRate && maxEng >= item.engagementRate) &&
          (gender === item.gender || gender === 'both') &&
          countryStatus &&
          item.instagramHandle &&
          (item.instagramHandle.includes(handle) || handle === '')
        ) {
          filteredItems.push(item);
        }
      });
      // put the filtered results into the table
      this.items = filteredItems;
      this.resultMessage = `Showing (Filtered Influencers) based on your searched results.`;
    },
    resetFilters() {
      // reset into initial state for filters
      this.fromAge = '';
      this.toAge = '';
      this.fromFol = '';
      this.toFol = '';
      this.fromEng = '';
      this.toEng = '';
      this.filGender = 'Any';
      this.igHandle = '';
      this.influencerGeos = [];
      this.paginate(this.currentPage);
    },
    searchByKeywords() {
      if (this.keyword === '') {
        this.reloadAll();
      } else {
        this.loading = true;
        InfluencerSearchAPIs
          .searchKeyword(this.searchKeywordPayload)
          .then(response => {
            this.updateItems(response);
            this.perPage = response.totalInfluencers;
            this.pagination.totalItems = response.totalInfluencers;
            this.pagination.rowsPerPage = -1;
            this.shouldCallApi = false;
            this.loading = false;
            // Deplicated
            this.resultMessage = `Showing related Influencers with your input " ` + this.keyword + ` "`;
          })
          .catch(error => {
            this.loading = true;
            console.log(error);
          });
      }
    },
    reloadAll() {
      // reset to default
      this.currentPage = 1;
      this.perPage = 15;
      this.keyword = '';
      this.igHandle = '';
      this.resetFilters();
    },
    remove(item) {
      this.influencerGeos.splice(this.influencerGeos.indexOf(item), 1);
      this.influencerGeos = [...this.influencerGeos];
    }
  },
  created() {
    this.paginate(this.currentPage);
    this.userGender_options = config.userGenderDisplay;
  }
};
</script>

<style>
#ig-handle {
  cursor: pointer;
}
.engagement {
  color: #81bee2;
  font-size: 20px;
}
.search-keyword-wrapper {
  padding-right: 2px;
}
.v-dialog-wrapper {
  margin-top: 5px;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// index.vue?d189c416